import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Popup from "reactjs-popup";

import { useMainStore } from "@/contexts/Store";

import { useScrollBoxWidth } from "../../../hooks/useScrollBoxWidth";
import { Icon } from "../../Elements";
import { getRecordName } from "../../helpers/nameForThemisModuleIdentifier";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sectionTag?: any;
  workspaceID?: number;
};

function AddNewButton({ workspaceID, sectionTag }: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // Hooks
  const history = useHistory();
  const moduleWorkspaces = mainStore.moduleWorkspaces.list;
  const { hasModuleWriteAccess } = mainStore.userPermissions;

  // State
  const [showPopup, setShowPopup] = useState(false);

  // Functions
  function onPopupOpen() {
    setShowPopup(true);
  }

  function onPopupClose() {
    setShowPopup(false);
  }

  async function createNewRiskRegister() {
    if (workspaceID) {
      const recordVersion = await mainStore.riskRegisters.create(
        workspaceID,
        sectionTag.id,
      );
      history.push(
        `/workspaces/${workspaceID}/modules/risk-register/${recordVersion.id}`,
      );
    }

    onPopupClose();
  }

  function setSelectedSectionTagID() {
    mainStore.riskRegisters.setSelectedSectionTagID(sectionTag.id);
  }

  // elements
  const renderPopupContent = (
    <div
      className="risk-register-add-new-popup"
      data-testid="risk-register-table-add-new-popup"
    >
      <Link
        to={`/workspaces/${workspaceID}/modules/risk-register/templates?sectionTagID=${sectionTag.id}`}
        onClick={setSelectedSectionTagID}
        data-testid="risk-register-table-add-new-popup-add-from-library"
      >
        Add From Library
      </Link>
      <button
        type="button"
        onClick={createNewRiskRegister}
        data-testid="risk-register-table-add-new-popup-add"
      >
        Add New {getRecordName("risk_register", moduleWorkspaces, true)}
      </button>
    </div>
  );

  const [ref, scrollWidth] = useScrollBoxWidth();

  return (
    <>
      <div
        onClick={onPopupOpen}
        className={classNames("add-new-procedures", "add-risk-register", {
          "add-new-procedures--disabled": !hasModuleWriteAccess,
          "pointer-events-none": !hasModuleWriteAccess,
        })}
        // @ts-expect-error TS(2322) FIXME: Type '(element: HTMLElement) => void' is not assig... Remove this comment to see the full error message
        ref={ref}
        style={{ width: `${scrollWidth - 125}px` }}
      >
        <div className="plus-sign">
          <Icon name="plus" color="generalWhite" size="de" />
        </div>
        <button
          data-testid="risk-register-table-add-new"
          className={classNames({ active: showPopup })}
        >
          Add New {getRecordName("risk_register", moduleWorkspaces, true)} +
        </button>
      </div>
      <Popup
        trigger={<div className="rr-hidden-trigger" />}
        position="bottom left"
        open={showPopup}
        onOpen={onPopupOpen}
        onClose={onPopupClose}
        keepTooltipInside
        nested
      >
        {renderPopupContent}
      </Popup>
    </>
  );
}

export default observer(AddNewButton);
